/* T8 primary-button text roll: wraps each primary button's label text in
   <span class="t-roll"><span class="t-roll__in">…</span></span> so CSS can slide the text up and a copy
   (text-shadow) in from below on hover. Re-wraps when scripts later replace a label ("Adding…", "Added"). */
(function () {
  'use strict';
  var SEL = '.t-btn--primary, .t8-hero__btn, .t8-scard__add, .t8-pf__add, .t8-ig__visit, .t8-cta__btn, .t8-cform__btn, .t8-cthero__btn, .t8-split__btn, .t8-pdp__atc, .t8-pdp-sticky__btn--atc, .t8-cgrid__apply, .t-btn--gold, .t8-pdp__buynow, .t8-pdp-sticky__btn--buy, .t8-pf__buy, .t8-acc__morebtn, .t8-cform__infobtn, .t8-doors__btn, .t8-footer__submit, .t8-rev__morebtn, .t8-pdp__pinbtn, .t8-pf__obtn.is-active';

  function wrapText(node) {
    var text = node.nodeValue;
    if (!text || !text.trim()) return;
    var outer = document.createElement('span');
    outer.className = 't-roll';
    var inner = document.createElement('span');
    inner.className = 't-roll__in';
    inner.textContent = text.trim();
    outer.appendChild(inner);
    node.parentNode.replaceChild(outer, node);
  }

  function process(btn) {
    // direct text nodes of the button, and of label spans that hold only text (e.g. [data-t8-scard-add-label])
    var targets = [btn];
    Array.prototype.forEach.call(btn.children, function (c) {
      if (c.tagName === 'SPAN' && !c.classList.contains('t-roll') && !c.querySelector('svg, img')) targets.push(c);
    });
    targets.forEach(function (el) {
      Array.prototype.slice.call(el.childNodes).forEach(function (n) { if (n.nodeType === 3) wrapText(n); });
    });
  }

  function init(root) {
    (root || document).querySelectorAll(SEL).forEach(function (btn) {
      process(btn);
      if (btn.dataset.tRoll) return;
      btn.dataset.tRoll = '1';
      if ('MutationObserver' in window) {
        new MutationObserver(function () { process(btn); }).observe(btn, { childList: true, subtree: true });
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
